import { Container, Title, Text, Box, ThemeIcon, Stack, Paper, SimpleGrid, Group } from "@mantine/core";
import {
  IconShieldCheck,
  IconLock,
  IconFileCheck,
  IconSparkles,
  IconFileText,
  IconCircleCheck,
  IconWorld,
} from "@tabler/icons-react";

export default function TrustSecuritySection() {
  return (
    <Box
      style={{ background: "linear-gradient(to top, rgba(235, 248, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%)" }}
      py={80}
    >
      <Container size="lg">
        <Stack gap="xl" align="center" mb={64}>
          <Title order={2} ta="center" style={{ fontSize: "2.5rem", fontWeight: 700, color: "#1a202c" }}>
            Built on Trust & Security
          </Title>
          <Text c="slate.6" size="lg" ta="center" maw={700}>
            Enterprise-grade security and compliance verification at every step
          </Text>
        </Stack>

        {/* Top 3 Features */}
        <SimpleGrid cols={{ base: 1, md: 3 }} spacing={40} mb={64}>
          <Stack align="center" gap="md">
            <ThemeIcon
              size={80}
              radius={80}
              color="#00A63E"
              variant="light"
              style={{
                background: "#F0FDF4",
                border: "2px solid #B9F8CF",
              }}
            >
              <IconShieldCheck size={40} />
            </ThemeIcon>
            <Text fw={700} size="lg" ta="center">
              Verified
            </Text>
            <Text c="slate.6" size="sm" ta="center" lh={1.6}>
              All companies undergo comprehensive compliance verification
            </Text>
          </Stack>

          <Stack align="center" gap="md">
            <ThemeIcon
              size={80}
              radius={80}
              color="primary"
              variant="light"
              style={{
                background: "#EFF6FF",
                border: "2px solid #BEDBFF",
              }}
            >
              <IconLock size={40} />
            </ThemeIcon>
            <Text fw={700} size="lg" ta="center">
              Secure
            </Text>
            <Text c="slate.6" size="sm" ta="center" lh={1.6}>
              Enterprise-grade security with encrypted data storage and controlled access
            </Text>
          </Stack>

          <Stack align="center" gap="md">
            <ThemeIcon
              size={80}
              radius={80}
              color="#9810FA"
              variant="light"
              style={{
                background: "#FAF5FF",
                border: "2px solid #E9D4FF",
              }}
            >
              <IconFileCheck size={40} />
            </ThemeIcon>
            <Text fw={700} size="lg" ta="center">
              NDA Protected
            </Text>
            <Text c="slate.6" size="sm" ta="center" lh={1.6}>
              Auto-generated NDAs and legal framework for confidential collaboration
            </Text>
          </Stack>
        </SimpleGrid>

        {/* Bottom 4 Features */}
        <SimpleGrid cols={{ base: 1, md: 2 }} spacing={30}>
          <Paper p="lg" radius="lg" bg="white" withBorder>
            <Group gap="md" wrap="nowrap" align="flex-start">
              <ThemeIcon size={48} radius="lg" color="primary" variant="light">
                <IconSparkles size={24} />
              </ThemeIcon>
              <div>
                <Text fw={600} size="md" mb={4}>
                  Secure Workspace
                </Text>
                <Text size="sm" c="slate.6" lh={1.5}>
                  Structured collaboration environment with document sharing, logs, and checklists
                </Text>
              </div>
            </Group>
          </Paper>

          <Paper p="lg" radius="lg" bg="white" withBorder>
            <Group gap="md" wrap="nowrap" align="flex-start">
              <ThemeIcon size={48} radius="lg" color="primary" variant="light">
                <IconFileText size={24} />
              </ThemeIcon>
              <div>
                <Text fw={600} size="md" mb={4}>
                  Document Control
                </Text>
                <Text size="sm" c="slate.6" lh={1.5}>
                  Version-controlled document repository with granular access permissions
                </Text>
              </div>
            </Group>
          </Paper>

          <Paper p="lg" radius="lg" bg="white" withBorder>
            <Group gap="md" wrap="nowrap" align="flex-start">
              <ThemeIcon size={48} radius="lg" color="primary" variant="light">
                <IconCircleCheck size={24} />
              </ThemeIcon>
              <div>
                <Text fw={600} size="md" mb={4}>
                  Compliance-Backed Verification
                </Text>
                <Text size="sm" c="slate.6" lh={1.5}>
                  Business license, tax registration, and industry certifications reviewed by experts
                </Text>
              </div>
            </Group>
          </Paper>

          <Paper p="lg" radius="lg" bg="white" withBorder>
            <Group gap="md" wrap="nowrap" align="flex-start">
              <ThemeIcon size={48} radius="lg" color="primary" variant="light">
                <IconWorld size={24} />
              </ThemeIcon>
              <div>
                <Text fw={600} size="md" mb={4}>
                  Global Network
                </Text>
                <Text size="sm" c="slate.6" lh={1.5}>
                  Connect with verified manufacturers and partners/businesses across 35+ countries worldwide
                </Text>
              </div>
            </Group>
          </Paper>
        </SimpleGrid>
      </Container>
    </Box>
  );
}
